import type { OklchColor } from './color';

export type ChromalLevel = {
  base: OklchColor;
  odd: OklchColor;
  baseCss: string;
  oddCss: string;
  oddIndex: number;
};

export type ChromalPuzzle = {
  levels: ChromalLevel[];
};

const isColor = (value: unknown): value is OklchColor => {
  if (!value || typeof value !== 'object') return false;
  const candidate = value as Partial<OklchColor>;
  return (
    typeof candidate.l === 'number' &&
    candidate.l > 0 &&
    candidate.l < 1 &&
    typeof candidate.c === 'number' &&
    candidate.c >= 0 &&
    typeof candidate.h === 'number' &&
    candidate.h >= 0 &&
    candidate.h < 360
  );
};

export function isChromalPuzzle(value: unknown): value is ChromalPuzzle {
  if (!value || typeof value !== 'object') return false;
  const levels = (value as Partial<ChromalPuzzle>).levels;
  return (
    Array.isArray(levels) &&
    levels.length === 10 &&
    levels.every(
      (level) =>
        level &&
        typeof level === 'object' &&
        isColor(level.base) &&
        isColor(level.odd) &&
        typeof level.baseCss === 'string' &&
        /^rgb\(\d+ \d+ \d+\)$/.test(level.baseCss) &&
        typeof level.oddCss === 'string' &&
        /^rgb\(\d+ \d+ \d+\)$/.test(level.oddCss) &&
        Number.isInteger(level.oddIndex) &&
        level.oddIndex >= 0 &&
        level.oddIndex < 6 &&
        level.base.c === level.odd.c &&
        level.base.h === level.odd.h &&
        level.base.l !== level.odd.l,
    )
  );
}
